import axios from 'axios'
import { API_URL } from 'shared/constants'
import { clearStorage, getStorage, navigationTo } from 'shared/utils'

export function setUrl(url = API_URL, options = { prod: false, isDev: false }) {
  if (options?.isDev) return process.env.REACT_APP_DEV_URL
  if (options?.prod) return API_URL
  if (process.env.NODE_ENV === 'development') return url
  return API_URL || url
}

const Axios = axios.create({
  // just set prod to true for using production server in local
  baseURL: `${API_URL}/api`,
  // baseURL: setUrl('https://modern-cuddly-beetle.ngrok-free.app/api', { prod: false, isDev: false }),
  headers: {
    'ngrok-skip-browser-warning': true
  }
})

Axios.interceptors.request.use(
  (req) => {
    const token = getStorage(1, 'token')
    if (!req.headers.Authorization && token) {
      req.headers.Authorization = token
      return req
    }
    return req
  },
  (err) => Promise.reject(err)
)
Axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if ((err?.response && err?.response?.status === 417) || err?.response?.status === 401) {
      clearStorage('token')
      navigationTo('/login')
      return Promise.reject(err)
    }
    return Promise.reject(err)
  }
)

export const axiosClient = Axios
